/**
 * Created by stephanpudras on 18.05.18.
 */

import React from 'react';
import {connect} from 'react-redux';

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

class SVGProgressCircle extends React.Component {
    constructor(props){
        super(props);
        let RADIUS = 54;
        let CIRCUMFERENCE = 2 * Math.PI * RADIUS;
        this.state = {circumference: CIRCUMFERENCE, strokeDasharray: CIRCUMFERENCE, strokeDashoffset:CIRCUMFERENCE, timer:0, interval:null};
        this.setInterval = this.setInterval.bind(this);
        this.setProgress = this.setProgress.bind(this);
        this.getTime = this.getTime.bind(this);
    }

    componentWillMount(){
        //this.setInterval()
    }

    setInterval(){
        this.setState({interval: setInterval(this.setProgress, 50)});
        setTimeout(() => {
            clearInterval(this.state.interval)
        }, this.props.time)
    }

    setProgress(){
        let dashoffset = this.state.strokeDashoffset - ((this.state.circumference/this.props.time) * (50));
        this.setState({strokeDashoffset: dashoffset, timer: this.state.timer + 50});
        //console.log(dashoffset)
    }

    getTime(){
        let minute = Math.floor(this.props.data.timer/60000);
        let second = ((this.props.data.timer%60000)/1000).toFixed(0);
        let milli = ((this.props.data.timer%1000)).toFixed(0);
        return minute + " : " + (second < 10 ? "0":"")+second + " : " + milli
    }

    render() {
        return (
            <div className="demo">
                <svg className="progress_circle" width="120" height="120" viewBox="0 0 120 120">
                    <circle className="progress__meter" cx="60" cy="60" r="54" strokeWidth="5" />
                    <circle  style={{strokeDasharray: this.props.data.strokeDasharray, strokeDashoffset: this.props.data.strokeDashoffset}} className="progress__value" cx="60" cy="60" r="54" strokeWidth="5" />
                    <text className="progress_text" x="25" y="56" transform="rotate(90 60,50)">{this.getTime()}</text>
                </svg>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SVGProgressCircle)



// WEBPACK FOOTER //
// ./src/components/SVGProgressCircle.js